import type { SVGProps } from 'react';

export function NoCommentsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={128}
      height={128}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          stroke="#999"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={8}
          d="M42.939 52c-13.84 0-25.06 9.82-25.06 21.93 0 5.55 2.38 10.61 6.27 14.47v13.72l13.7-6.72c1.65.3 3.35.46 5.1.46 13.84 0 25.06-9.82 25.06-21.93S56.789 52 42.949 52h-.01ZM50.86 36.41C55.9 26.73 67.05 20 80 20c17.67 0 31.999 12.54 31.999 28 0 7.09-3.04 13.54-8 18.48V84l-17.49-8.58c-.9.16-1.81.29-2.74.39"
        />
        <path
          stroke="#616161"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
          d="M73.5 124.5c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
        />
        <path
          fill="#616161"
          d="M69.75 111a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM77.25 111a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
        />
        <path
          stroke="#616161"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
          d="M68.352 115.5c1.03 1.79 2.94 3 5.15 3 2.21 0 4.12-1.21 5.15-3M18.25 41.5c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
        />
        <path
          fill="#616161"
          d="M14.5 28a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM22 28a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
        />
        <path
          stroke="#616161"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
          d="M13.75 34h9M42.75 4.5h24M42.75 10.5h16.5M101.25 103.5h19.5M101.25 109.5h10.5"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h128v128H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
